<template>
  <div>
    <v-snackbar
      v-model="Notification"
      :timeout="timeout"
      :top="true"
      dark
      :color="color"
    >
      {{ errorMsg }}
    </v-snackbar>
    <v-data-table
      :headers="headers"
      :items="projects"
      :loading="Loading"
      :items-per-page="5"
    >
   <template v-slot:item.isPublished="{ item }">
        <PublishedChip :item="item" />
      </template>
    

      <template v-slot:item.Download="{ item }">
        <v-icon small @click="createPDF(item)">
          mdi-arrow-collapse-down
        </v-icon>
      </template>

      <template v-slot:item.Modify="{ item }">
        <v-icon small @click="openNewWindow(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:item.Publish="{ item }">
        <v-icon
          v-if="!item.isPublished"
          small
          @click="publish(item)"
        >
          mdi-publish
        </v-icon>

        <v-icon
          v-if="item.isPublished"
          small
          @click="publish(item)"
        >
          mdi-close
        </v-icon>
      </template>
    </v-data-table>
    <NewEditConductorType
      :visible="showNewConductorWindow"
      @close="closeWindow"
      WindowLable="Edit Conductor Type"
      :conductorData="ConductorData"
      :EditMode="true"
    />
    <ConfirmationBox
      confirmationTitle="Delete Conductor"
      bodyText="Are you sure you want to delete?"
      :visible="ShowDeleteConfirmation"
      @close="deleteConfirm"
    />
  </div>
</template>

<script>
import { bus } from "../main";
import jsPDF from "jspdf";
import ConfirmationBox from "@/components/deleteConfirmation.vue";
import NewEditConductorType from "@/components/newEditConductorType.vue";
import ConductorStore from "@/services/conductorstore.js";
import PublishedChip from "@/components/publishedStatusChip.vue";
export default {
  name: "AdminConductorType",
  props: ["projects", "Loading"],
  components: {
    NewEditConductorType,ConfirmationBox,PublishedChip
  },
  data() {
    return {
      deleteItemObj : "",
      isConfirmed : false,
      ShowDeleteConfirmation : false,
      showNewConductorWindow: false,
      responseData: [],
      timeout: 2000,
      color: "",
      ConductorData: [],
      errorMsg: "",
      Notification: false,
      showForm: false,
      showEditForm: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "Feeder Type", value: "feederType", align: 'center' },
        { text: "Resistance", value: "resistanceOhmsPerKm", align: 'center' },
        { text: "Reactance", value: "reactanceOhmsPerKm", align: 'center' },
        { text: "Peak Current", value: "peakCurrentCarryingCapacityAmps", align: 'center' },
        { text: "Published", value: "isPublished", align: 'center' },
        { text: "Edit", value: "Modify", align: 'center', sortable: false },
        { text: "Delete", value: "delete", align: 'center', sortable: false },
        { text: "Publish/Unpublish", value: "Publish", align: 'center', sortable: false },
      ],
    };
  },
  created() {
    bus.$on("justAddedConductorRecord", (data) => {
      this.projects.push(data);
    });
    bus.$on("justEditedConductorRecord", (data) => {
       let idx = -1;
      const newProjects = this.projects.map(p => p);
      newProjects.forEach((element, index) => {
        if (element._id === data._id) {
          idx = index;
        }
      });
      if (idx !== -1) {
        newProjects[idx] = {...data};
        this.projects = newProjects;
      }
    });
  },
  methods: {
    createPDF(item) {
      let pdfName = item.Title;
      var doc = new jsPDF();
      var temp = [
        "upperlimitforcapacityupgradation:" +
          item.upperLimitForCapacityUpgradation,
        "transmissioncapacitycost:" + item.transmissionCapacityCost.toString(),
        "Title:" + item.Title,
        "analysislevel :" + item.analysisLevel.toString(),
        "technology :" + item.technology,
        "substationname :" + item.substationName,
        "storageinterconnectionlocation:" + item.storageInterConnectionLocation,
        "storagechargingdischargingstrategy:" +
          item.storageChargingDischargingStrategy,
        "storagecapacity:" + item.storageCapacity.toString(),
        "Status:" + item.status,
        "State:" + item.state,
        "solarinterconnectionlocation:" + item.solarInterConnectionLocation,
        "solarcapacity:" + item.solarCapacity.toString(),
        "sanctionedload:" + item.sanctionedLoad.toString(),
        "resistance:" + item.resistance.toString(),
        "published:" + item.published.toString(),
        "pincode:" + item.pincode.toString(),
        "loadshiftedafterupgradation:" +
          item.loadShiftedAfterUpgradation.toString(),
        "invertercapacitystorage:" + item.inverterCapacityStorage.toString(),
        "generationcapacitycost:" + item.generationCapacityCost.toString(),
        "feedervoltage:" + item.feederVoltage.toString(),
        "feedertype:" + item.feederType.toString(),
        "feedername:" + item.feederName.toString(),
        "feederlength:" + item.feederLength.toString(),
        "createdDate:" + item.createdDate.toString(),
        "costofpm2_5:" + item.costOfPm2_5.toString(),
        "costofno2:" + item.costOfNo2.toString(),
        "costofcorbon:" + item.costOfCorbon.toString(),
        "cosofso2:" + item.cosOfSo2.toString(),
        "conductiortype:" + item.conductiorType.toString(),
        "changeinloadyearly:" + item.changeInloadYearly.toString(),
        "carryingcapacitypeak:" + item.carryingCapacityPeak.toString(),
        "avgtransmissionlosses:" + item.avgTransmissionLosses.toString(),
        "analysisperiod:" + item.analysisPeriod.toString(),
      ];

      doc.text(temp, 10, 10);
      doc.save(pdfName + ".pdf");
    },

    closeWindow() {
      this.showNewConductorWindow = false;
    },
    openNewWindow(item) {
      this.showNewConductorWindow = true;
      this.ConductorData = item;
    },

    getColor(Status) {
      if (Status === false) return "red";
      else return "green";
    },
    publish(item) {
    
      this.loading = true;
      ConductorStore.methods.doPublish(item._id, !item.isPublished).then((res) => {
        item.isPublished = !item.isPublished;
        bus.$emit("publishNotification",item.isPublished,res._status,'')
        this.loading = false;
      });
      
    },
    deleteItem(item) {
      this.deleteItemObj = item;
      this.ShowDeleteConfirmation = true;
    },

    deleteConfirm(e) {
      this.ShowDeleteConfirmation = false;
      this.isConfirmed = e;
      if (e) {
        this.doDelete(this.deleteItemObj);
      }
    },
    async doDelete(item) {
      this.loading = true;
      await ConductorStore.methods.delete(item._id, !item.isPublished).then((res) => {
      const _status = res.status =="204" ? 'OK' : ''
       bus.$emit("deleteNotification",_status)
       if(_status==='OK'){
          this.projects.splice(this.projects.indexOf(item), 1);
       }
      }).catch((error) => {
          bus.$emit("deleteNotification",error)
        });
    },

    Duplicate(item, mode) {
      this.showNewConductorWindow = true;
      // console.log(item, mode);
    },
  },
};
</script>